exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#global[data-v-e08a0a38]{height:75%;width:100%;border:1px solid #ddd;overflow-y:scroll}", ""]);

// exports
